var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit1SvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.08576H6C4.89543 4.08576 4 4.98119 4 6.08576V18.0858C4 19.1903 4.89543 20.0858 6 20.0858H18C19.1046 20.0858 20 19.1903 20 18.0858V12.0858M18.4142 8.49996L19.5 7.41421C20.281 6.63316 20.281 5.36683 19.5 4.58579C18.7189 3.80474 17.4526 3.80474 16.6715 4.5858L15.5858 5.67154M18.4142 8.49996L12.3779 14.5363C12.0987 14.8155 11.7431 15.0059 11.356 15.0833L8.41422 15.6716L9.00257 12.7299C9.08001 12.3427 9.27032 11.9871 9.54951 11.7079L15.5858 5.67154M18.4142 8.49996L15.5858 5.67154",
    stroke: "#E4A400",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit1SvgrepoCom);
export default __webpack_public_path__ + "static/media/edit-1-svgrepo-com.2f13fb0e174deb79f6a03d62d2a9d6e1.svg";
export { ForwardRef as ReactComponent };